import axios from 'axios';
import Const from './consts';
import BasicService from './basic.service';


export default class ApiHome extends BasicService {

    api = Const.api + Const.path.home;
    
    get(company_code) { return axios.get(this.api + `?company_code=${company_code}`); }
}


// WEBPACK FOOTER //
// ./src/utils/api.home.js